import { UserProfile } from './user-profile';
var User = /** @class */ (function () {
    function User(technicalID) {
        this.profile = new UserProfile(technicalID);
    }
    User.prototype.getProfile = function () {
        return this.profile;
    };
    return User;
}());
export { User };
